import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { CriteriaDirectoryChargeCheckboxOption } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailCriteriaDirectoryCheckboxOption";
import { cntrTspStatusDropdownOption, emptyIndDropdownOption, rfTempUnitDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { useChargeDetailTracked } from "presentation/store/ChargeDetailMaintenance/ChargeDetailProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NbisDateTimePickerComponent from "presentation/view/components/NbisDateTimePickerComponent";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IFieldValue, InputField } from "veronica-ui-component/dist/component/core";

const CntrInfoForm = () => {
    const CHARGEDETAIL_CONSTANT = ChargeDetailConstant.Charge;
    const [chargeDetailState] = useChargeDetailTracked();
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate;
    const chargeDetailVM = useChargeDetailVM();
    const enabledCriteria = useMemo(() => CriteriaDirectoryChargeCheckboxOption?.find(item => chargeDetailState.enabledSearchCriteria[item.key]), [chargeDetailState.enabledSearchCriteria]);
    const onNumberFieldChange = useCallback((event: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
        chargeDetailVM.onInputTextChange(event, fieldName, chargeBatchUpdate, 'chargeBatchUpdate');
    }, [chargeDetailVM, chargeBatchUpdate]);

    const memoCntrTspStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeBatchUpdate.cntrTspStatus ?? ""}
                fieldValue={chargeBatchUpdate.cntrTspStatus}
                fieldLabel={CHARGEDETAIL_CONSTANT.CNTR_TSP_STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrTspStatus'}
                maxLength={60}
                options={cntrTspStatusDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.CNTR_TSP_STATUS])

    const memoEmptyInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeBatchUpdate.emptyInd ?? ""}
                fieldValue={chargeBatchUpdate.emptyInd}
                fieldLabel={CHARGEDETAIL_CONSTANT.EMPTY_IND}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'emptyInd'}
                maxLength={60}
                options={emptyIndDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.EMPTY_IND])

    const memoImcoCode1 = useMemo(() =>
        <div className='im-flex-row-item'>
            <InputField
                width='330px'
                maxLength={50}
                label={CHARGEDETAIL_CONSTANT.IMCO_CODE}
                type="text"
                value={chargeBatchUpdate.imcoCode1 ?? ''}
                onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'imcoCode1', chargeBatchUpdate, 'chargeBatchUpdate')}
                allowedSpecialChars={'all'} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.IMCO_CODE])

    const memoImcoCode2 = useMemo(() =>
        <div className='im-flex-row-item'>
            <InputField
                width='330px'
                maxLength={50}
                label={CHARGEDETAIL_CONSTANT.IMCO_CODE2}
                type="text"
                value={chargeBatchUpdate.imcoCode2 ?? ''}
                onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'imcoCode2', chargeBatchUpdate, 'chargeBatchUpdate')}
                allowedSpecialChars={'all'} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.IMCO_CODE2])

    const memoImcoCode3 = useMemo(() =>
        <div className='im-flex-row-item'>
            <InputField
                width='330px'
                maxLength={50}
                label={CHARGEDETAIL_CONSTANT.IMCO_CODE3}
                type="text"
                value={chargeBatchUpdate.imcoCode3 ?? ''}
                onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'imcoCode3', chargeBatchUpdate, 'chargeBatchUpdate')}
                allowedSpecialChars={'all'} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.IMCO_CODE3])

    const memoOlDimen = useMemo(() =>
        <div className='im-flex-row-item'>
            <NumberInputComponent
                label={CHARGEDETAIL_CONSTANT.OL_DIMEN}
                width='330px'
                fieldName={"olDimen"}
                value={chargeBatchUpdate.olDimen || ''}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any) => onNumberFieldChange(e, 'olDimen')}
            />
        </div>
        , [chargeBatchUpdate, CHARGEDETAIL_CONSTANT.OL_DIMEN, onNumberFieldChange])

    const memoOwDimen = useMemo(() =>
        <div className='im-flex-row-item'>
            <NumberInputComponent
                label={CHARGEDETAIL_CONSTANT.OW_DIMEN}
                width='330px'
                fieldName={"owDimen"}
                value={chargeBatchUpdate.owDimen || ''}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any) => onNumberFieldChange(e, 'owDimen')}
            />
        </div>
        , [chargeBatchUpdate, CHARGEDETAIL_CONSTANT.OW_DIMEN, onNumberFieldChange])

    const memoOhDimen = useMemo(() =>
        <div className='im-flex-row-item'>
            <NumberInputComponent
                label={CHARGEDETAIL_CONSTANT.OH_DIMEN}
                width='330px'
                fieldName={"ohDimen"}
                value={chargeBatchUpdate.ohDimen || ''}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any) => onNumberFieldChange(e, 'ohDimen')}
            />
        </div>
        , [chargeBatchUpdate, CHARGEDETAIL_CONSTANT.OH_DIMEN, onNumberFieldChange])

    const memoCntrType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeBatchUpdate.cntrType ?? ""}
                fieldValue={chargeBatchUpdate.cntrType}
                fieldLabel={CHARGEDETAIL_CONSTANT.TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrType'}
                maxLength={60}
                options={chargeDetailState.dynamicOptions.typeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeBatchUpdate, chargeDetailState.dynamicOptions.typeDropdownOptions, chargeDetailVM, CHARGEDETAIL_CONSTANT.TYPE])

    const memoRfTemp = useMemo(() =>
        <div className='im-flex-row-item'>
            <NumberInputComponent
                label={CHARGEDETAIL_CONSTANT.RF_TEMP}
                width='150px'
                fieldName={"rfTemp"}
                value={chargeBatchUpdate.rfTemp || ''}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any) => onNumberFieldChange(e, 'rfTemp')}
            />
        </div>
        , [chargeBatchUpdate, CHARGEDETAIL_CONSTANT.RF_TEMP, onNumberFieldChange])


    const memoRfTempUnit = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeBatchUpdate.rfTempUnit ?? ""}
                fieldValue={chargeBatchUpdate.rfTempUnit}
                fieldLabel={CHARGEDETAIL_CONSTANT.RF_TEMP_UNIT}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'rfTempUnit'}
                maxLength={60}
                options={rfTempUnitDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.RF_TEMP_UNIT])

    const memoGrossWt = useMemo(() =>
        <div className='im-flex-row-item'>
            <InputField
                width='150px'
                maxLength={50}
                label={CHARGEDETAIL_CONSTANT.GROSS_WT}
                type="number"
                value={chargeBatchUpdate.grossWt ?? ''}
                onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'grossWt', chargeBatchUpdate, 'chargeBatchUpdate')}
                allowedSpecialChars={'all'} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.GROSS_WT])

    const memoForwarderCode = useMemo(() =>
        <div className='im-flex-row-item'>
            <InputField
                width='150px'
                maxLength={10}
                label={CHARGEDETAIL_CONSTANT.FORWARDER_CODE}
                type="text"
                value={chargeBatchUpdate.forwarderCode1 || ''}
                onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'forwarderCode1', chargeBatchUpdate, 'chargeBatchUpdate')}
                allowedSpecialChars={'all'} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.FORWARDER_CODE])

    const memoReference = useMemo(() =>
        <div className='im-flex-row-item'>
            <InputField
                width='330px'
                maxLength={50}
                label={CHARGEDETAIL_CONSTANT.REFERENCE_NO}
                type="text"
                value={chargeBatchUpdate.reference || ''}
                onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'reference', chargeBatchUpdate, 'chargeBatchUpdate')}
                allowedSpecialChars={'all'} />
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.REFERENCE_NO])

    const memoDischarge = useMemo(() =>
        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
            <div className='im-flex-row-item'>
                <NbisDateTimePickerComponent
                    label={CHARGEDETAIL_CONSTANT.DISCHARGE_DATE_TIME}
                    width='330px'
                    date={chargeBatchUpdate.dischargeDatetime}
                    onDateChange={chargeDetailVM.onDatePickerChange}
                    fieldName={"dischargeDatetime"} />
            </div>
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.DISCHARGE_DATE_TIME])

    const memoGateOut = useMemo(() =>
        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
            <div className='im-flex-row-item'>
                <NbisDateTimePickerComponent
                    label={CHARGEDETAIL_CONSTANT.GATE_OUT_DATE_TIME}
                    width='330px'
                    date={chargeBatchUpdate.gateOutDatetime}
                    onDateChange={chargeDetailVM.onDatePickerChange}
                    fieldName={"gateOutDatetime"} />
            </div>
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.GATE_OUT_DATE_TIME])

    const memoDelivery = useMemo(() =>
        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
            <div className='im-flex-row-item'>
                <NbisDateTimePickerComponent
                    label={CHARGEDETAIL_CONSTANT.DELIVERY_DATE_TIME}
                    width='330px'
                    date={chargeBatchUpdate.deliveryDatetime}
                    onDateChange={chargeDetailVM.onDatePickerChange}
                    fieldName={"deliveryDatetime"} />
            </div>
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.DELIVERY_DATE_TIME])

    const memoReceive = useMemo(() =>
        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
            <div className='im-flex-row-item'>
                <NbisDateTimePickerComponent
                    label={CHARGEDETAIL_CONSTANT.RECEIVE_DATE_TIME}
                    width='330px'
                    date={chargeBatchUpdate.receiveDatetime}
                    onDateChange={chargeDetailVM.onDatePickerChange}
                    fieldName={"receiveDatetime"} />
            </div>
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.RECEIVE_DATE_TIME])

    const memoReceivalCutoff = useMemo(() =>
        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
            <div className='im-flex-row-item'>
                <NbisDateTimePickerComponent
                    label={CHARGEDETAIL_CONSTANT.RECEIVAL_CUTOFF_TIME}
                    width='330px'
                    date={chargeBatchUpdate.receivalCutoffDatetime}
                    onDateChange={chargeDetailVM.onDatePickerChange}
                    fieldName={"receivalCutoffDatetime"} />
            </div>
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.RECEIVAL_CUTOFF_TIME])

    const memoGateIn = useMemo(() =>
        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
            <div className='im-flex-row-item'>
                <NbisDateTimePickerComponent
                    label={CHARGEDETAIL_CONSTANT.GATE_IN}
                    width='330px'
                    date={chargeBatchUpdate.gateInDatetime}
                    onDateChange={chargeDetailVM.onDatePickerChange}
                    fieldName={"gateInDatetime"} />
            </div>
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.GATE_IN])

    const memoLoading = useMemo(() =>
        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
            <div className='im-flex-row-item'>
                <NbisDateTimePickerComponent
                    label={CHARGEDETAIL_CONSTANT.LOADING_DATE_TIME}
                    width='330px'
                    date={chargeBatchUpdate.loadingDatetime}
                    onDateChange={chargeDetailVM.onDatePickerChange}
                    fieldName={"loadingDatetime"} />
            </div>
        </div>
        , [chargeBatchUpdate, chargeDetailVM, CHARGEDETAIL_CONSTANT.LOADING_DATE_TIME])

    if (!enabledCriteria) return null;

    return <>
        <CriteriaItemContainer>
            {memoCntrTspStatus}
            {memoEmptyInd}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoImcoCode1}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoImcoCode2}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoImcoCode3}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoCntrType}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoRfTemp}
            {memoRfTempUnit}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoOlDimen}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoOwDimen}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoOhDimen}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoGrossWt}
            {memoForwarderCode}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoReference}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoDischarge}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoGateOut}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoDelivery}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoReceive}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoReceivalCutoff}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoGateIn}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoLoading}
        </CriteriaItemContainer>

    </>;
}
export default memo(CntrInfoForm);